import { RestfulClient, Session } from '@benzinga/session';
import { SafePromise } from '@benzinga/safe-await';
import { ArticleEnvironment } from '../environment';
import { InternalNode } from '../entities/article';

export class InternalContentRestful extends RestfulClient {
  constructor(session: Session) {
    super(session.getEnvironment(ArticleEnvironment).internalContentUrl, session, { 'x-device-key': true });
  }

  getInternalNode = (nodeId: number | string): SafePromise<InternalNode> => {
    const url = this.URL(`content/nid/${nodeId}`);
    return this.get(url, {
      allowsAnonymousAuth: true,
      headers: { apiKey: this.session.getEnvironment(ArticleEnvironment).internalContentKey },
    });
  };
}
